export enum ShoppingCartActionTypes {
  SELECT_FUND = 'SELECT_FUND',
  DESELECT_FUND = 'DESELECT_FUND',
  UPDATE_FUND_AMOUNT = 'UPDATE_FUND_AMOUNT',
  UPDATE_MONTH_SELECTION = 'UPDATE_MONTH_SELECTION',
  UPDATE_DAY_SELECTION = 'UPDATE_DAY_SELECTION',

  ADD_TO_NEW_FUND = 'ADD_TO_NEW_FUND',
  ADD_TO_NEW_FUND_ERROR = 'ADD_TO_NEW_FUND_ERROR',
  EMPTY_NEW_FUND = 'EMPTY_NEW_FUND',
  EMPTY_NEW_FUND_ERROR = 'EMPTY_NEW_FUND_ERROR',
  SWAP_NEW_FUND = 'SWAP_NEW_FUND',
  GET_RECURRING_START_DATE_DATA = 'GET_RECURRING_START_DATE_DATA',

  RESET_TRANSACTION = 'RESET_TRANSACTION',
}
